import type {  Reducer,Effect } from 'umi';
import {getChildDropDownList} from '@/services/childGames';

export type GamesModelState = {
  childGameList?: any[];
}
export type GamesModelType = {
    namespace: string;
    state: GamesModelState;
    reducers: {
      changeChildGameList: Reducer<GamesModelState>;
    };
    effects: {
      getChildGameList: Effect;
    };
  }
const GamesModel: GamesModelType = {
    namespace: 'games',
    state: {
      childGameList: [],
    },
    reducers: {
      changeChildGameList(state, {payload}) {
        return {
          ...state,
          childGameList: payload,
        };
      }
    },
    effects: {
      *getChildGameList({ payload }, { call, put }) {
        const response = yield call(getChildDropDownList, payload.id);
        if(response.code === 0) { 
          yield put({type:"changeChildGameList",payload:response.data});
        }
      },
    },
};
  
export default GamesModel